import { Stack } from '@mui/material';
import { PropsWithChildren } from 'react';

export const ChatActions = ({ children }: PropsWithChildren) => {
  return (
    <Stack
      spacing={2}
      direction="row"
      sx={{
        paddingTop: 2,
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
      }}
    >
      {children}
    </Stack>
  );
};
